import AbstractApiReducer from 'store/apiReducer';

class UsagerReducer extends AbstractApiReducer {
    constructor() {
        super(process.env.REACT_APP_API_DETENTEURS_URL);
    }
}
const usagerClientReducer = new UsagerReducer();

// add withCredentials option
usagerClientReducer.getInstance().interceptors.request.use(
    (config) => {
        const configuration = config;
        configuration.withCredentials = true;
        configuration.xsrfCookieName = 'XSRF-TOKEN-DETENTEURS'; // la même config dans backend dneustadt_csrf_cookie.yaml
        configuration.xsrfHeaderName = 'X-XSRF-TOKEN-DETENTEURS';
        return configuration;
    },
    (error) => {
        return Promise.reject(error);
    },
);

export default usagerClientReducer;
